import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { HTML_LANG, normalizeLanguage } from "@/navigations/locale";
import { LanguageEnum } from "@/types/enums";

interface LanguageSyncProps {
  lang: LanguageEnum;
}

export function LanguageSync({ lang }: LanguageSyncProps) {
  const { i18n } = useTranslation();

  useLayoutEffect(() => {
    if (normalizeLanguage(i18n.language) !== lang) {
      void i18n.changeLanguage(lang);
    }
    document.documentElement.lang = HTML_LANG[lang];
  }, [i18n, lang]);

  return <Outlet />;
}

export default LanguageSync;
